// extracted by mini-css-extract-plugin
module.exports = {"heading":"ImprintPage_heading__1snI-","content":"ImprintPage_content__1q6yU"};